<template>
  <Select
    v-model="currentLocale"
    :options="locales"
    option-label="name"
    option-value="code"
    size="small"
  >
    <template #value="{ value }">
      <span class="flex items-center gap-2">
        <span>{{ localeMap[value]?.flag }}</span>
        <span>{{ localeMap[value]?.name }}</span>
      </span>
    </template>
    <template #option="{ option }">
      <span class="flex items-center gap-2">
        <span>{{ option.flag }}</span>
        <span>{{ option.name }}</span>
      </span>
    </template>
  </Select>
</template>

<script setup lang="ts">
import Select from "primevue/select";
import { computed } from "vue";

const { locale, setLocale } = useI18n();

const locales = [
  { code: "it", name: "Italiano", flag: "🇮🇹" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "ro", name: "Română", flag: "🇷🇴" },
];

const localeMap = Object.fromEntries(locales.map((l) => [l.code, l]));

const currentLocale = computed({
  get: () => locale.value,
  set: (val) => setLocale(val),
});
</script>
